import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { commentaries, type CreateCommentaryRequest } from "../../../api/commentaries.service.js";
import { useMutation } from "../../../hooks/useApi.js";
import { ROUTES } from "../../../routes.js";
import CommentaryForm from "./CommentaryForm.js";
import {
  buildCreateCommentaryRequest,
  commentaryFormDefaultValues,
  type CommentaryFormValues,
  type TaxonomyLabelMaps,
  type TaxonomySelectionState,
} from "./commentaryForm.helpers.js";

function CreateCommentaryPage() {
  const navigate = useNavigate();
  const { mutate: createCommentary } = useMutation<
    Awaited<ReturnType<typeof commentaries.create>>,
    [CreateCommentaryRequest]
  >(commentaries.create);

  const initialValues = useMemo(() => commentaryFormDefaultValues, []);

  const handleSubmit = async (
    values: CommentaryFormValues,
    selectionState: TaxonomySelectionState,
    labelMaps: TaxonomyLabelMaps,
  ) => {
    const request = buildCreateCommentaryRequest(values, selectionState, labelMaps);
    await createCommentary(request);
  };

  return (
    <CommentaryForm
      mode="create"
      title="Create Commentary"
      submitLabel="Create"
      loadingLabel="Creating..."
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onCancel={() => navigate(-1)}
      onDone={() => navigate(ROUTES.research.commentaries)}
    />
  );
}

export default CreateCommentaryPage;
